// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@300;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-dark: #271F12;
  --color-olive: #526015;
  --color-gold: #DEB241;
}

.hero {
  height: 120vh;
  width: 100%;
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: 'Josefin Sans', sans-serif;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.3)
  );
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 4rem;
  position: relative;
  z-index: 10;
}

.logo-container {
  flex-shrink: 0;
}

.logo {
  height: 50px;
  width: auto;
}

.nav-links {
  display: flex;
  gap: 2.5rem;
  align-items: center;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 400;
  transition: opacity 0.3s ease;
}

.nav-links a:hover {
  opacity: 0.8;
}

.nav-cta {
  background-color: var(--color-gold);
  color: var(--color-dark);
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Josefin Sans', sans-serif;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.nav-cta:hover {
  background-color: #c99f3a;
}

.hero-top {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 1rem 4rem;
  position: relative;
  z-index: 10;
}

.contact-info {
  display: flex;
  gap: 3rem;
  align-items: center;
}

.contact-item {
  display: flex;
  align-items: left;
  gap: 1rem;
  color: white;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.contact-item:hover {
  opacity: 0.9;
}

.contact-icon {
  width: 48px;
  height: 48px;
  flex-shrink: 0;
}

.contact-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
}

.contact-label {
  font-size: 0.75rem;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 300;
  color: white;
}

.contact-value {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
}

.hero-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 9rem;
  position: relative;
  z-index: 10;
  max-width: 900px;
  margin: 0;
}

.hero h1 {
  color: white;
  font-size: 4rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  text-align: left;
}

.hero p {
  color: white;
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;
  text-align: left;
}

.cta-button {
  background-color: var(--color-gold);
  color: var(--color-dark);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  font-family: 'Josefin Sans', sans-serif;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  align-self: flex-start;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cta-button:hover {
  background-color: #c99f3a;
}

@media (max-width: 1024px) {
  .nav {
    padding: 1.5rem 2rem;
  }

  .nav-links {
    gap: 1.5rem;
  }

  .hero-top {
    padding: 1rem 2rem;
  }

  .contact-info {
    gap: 2rem;
  }

  .contact-icon {
    width: 40px;
    height: 40px;
  }

  .hero-content {
    padding: 0 2rem;
  }

  .hero h1 {
    font-size: 3.5rem;
  }
}

@media (max-width: 768px) {
  .hero {
    height: 100vh;
  }

  .nav {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .nav-links {
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
  }

  .hero-top {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .contact-info {
    flex-direction: column;
    gap: 1rem;
  }

  .contact-item {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .contact-text {
    align-items: center;
  }

  .contact-icon {
    width: 32px;
    height: 32px;
  }

  .hero-content {
    margin: 0 auto;
    text-align: center;
    align-items: center;
    padding: 0 1.5rem;
  }

  .hero h1 {
    font-size: 2.5rem;
    text-align: center;
  }

  .hero p {
    font-size: 1.1rem;
    text-align: center;
  }

  .cta-button {
    align-self: center;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/Hero.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@300;500;700&display=swap');\n\n:root {\n  --color-dark: #271F12;\n  --color-olive: #526015;\n  --color-gold: #DEB241;\n}\n\n.hero {\n  height: 120vh;\n  width: 100%;\n  background-size: cover;\n  background-position: center bottom;\n  background-repeat: no-repeat;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Josefin Sans', sans-serif;\n}\n\n.hero-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0.3)\n  );\n}\n\n.nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 4rem;\n  position: relative;\n  z-index: 10;\n}\n\n.logo-container {\n  flex-shrink: 0;\n}\n\n.logo {\n  height: 50px;\n  width: auto;\n}\n\n.nav-links {\n  display: flex;\n  gap: 2.5rem;\n  align-items: center;\n}\n\n.nav-links a {\n  color: white;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 400;\n  transition: opacity 0.3s ease;\n}\n\n.nav-links a:hover {\n  opacity: 0.8;\n}\n\n.nav-cta {\n  background-color: var(--color-gold);\n  color: var(--color-dark);\n  border: none;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 700;\n  font-family: 'Josefin Sans', sans-serif;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.nav-cta:hover {\n  background-color: #c99f3a;\n}\n\n.hero-top {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 1rem 4rem;\n  position: relative;\n  z-index: 10;\n}\n\n.contact-info {\n  display: flex;\n  gap: 3rem;\n  align-items: center;\n}\n\n.contact-item {\n  display: flex;\n  align-items: left;\n  gap: 1rem;\n  color: white;\n  text-decoration: none;\n  transition: opacity 0.3s ease;\n}\n\n.contact-item:hover {\n  opacity: 0.9;\n}\n\n.contact-icon {\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n}\n\n.contact-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  align-items: flex-start;\n}\n\n.contact-label {\n  font-size: 0.75rem;\n  opacity: 0.9;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 300;\n  color: white;\n}\n\n.contact-value {\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1;\n}\n\n.hero-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0 9rem;\n  position: relative;\n  z-index: 10;\n  max-width: 900px;\n  margin: 0;\n}\n\n.hero h1 {\n  color: white;\n  font-size: 4rem;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  text-align: left;\n}\n\n.hero p {\n  color: white;\n  font-size: 1.25rem;\n  font-weight: 300;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n  text-align: left;\n}\n\n.cta-button {\n  background-color: var(--color-gold);\n  color: var(--color-dark);\n  border: none;\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  font-family: 'Josefin Sans', sans-serif;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  align-self: flex-start;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.cta-button:hover {\n  background-color: #c99f3a;\n}\n\n@media (max-width: 1024px) {\n  .nav {\n    padding: 1.5rem 2rem;\n  }\n\n  .nav-links {\n    gap: 1.5rem;\n  }\n\n  .hero-top {\n    padding: 1rem 2rem;\n  }\n\n  .contact-info {\n    gap: 2rem;\n  }\n\n  .contact-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .hero-content {\n    padding: 0 2rem;\n  }\n\n  .hero h1 {\n    font-size: 3.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    height: 100vh;\n  }\n\n  .nav {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .nav-links {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 1rem;\n  }\n\n  .hero-top {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .contact-info {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .contact-item {\n    flex-direction: column;\n    text-align: center;\n    gap: 0.5rem;\n  }\n\n  .contact-text {\n    align-items: center;\n  }\n\n  .contact-icon {\n    width: 32px;\n    height: 32px;\n  }\n\n  .hero-content {\n    margin: 0 auto;\n    text-align: center;\n    align-items: center;\n    padding: 0 1.5rem;\n  }\n\n  .hero h1 {\n    font-size: 2.5rem;\n    text-align: center;\n  }\n\n  .hero p {\n    font-size: 1.1rem;\n    text-align: center;\n  }\n\n  .cta-button {\n    align-self: center;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
